// TODO: bundling data
export const formatReportText = (
  name: string,
  ca: string,
  symbol: string,
  score: number,
  hasPastRug: boolean,
) => {
  const text = `🚨SCAM ALERT
${name} $${symbol}
${ca}

🧠AI Safety Score: ${score}%
${hasPastRug ? 'Creator has a suspicious history!' : ''}
Solana Full Report: antirug.ai/ca/${ca}

🔁❤️@Antirug_ai`;

  return encodeURIComponent(text);
};

export const formatTweetText = (symbol: string, score: number, message: string, ca: string) => {
  const text = `$${symbol} - Safety Score: ${score}%

${ca}

${message}

See more data at #ANTIRUG: https://antirug.ai`;

  return encodeURIComponent(text);
};

export function formatNumber(num: number) {
  if (num < 1000) return num.toString();

  const suffixes = ['K', 'M', 'B', 'T', 'Q'];
  const tier = Math.floor(Math.log10(num) / 3);
  const suffix = suffixes[tier - 1];
  const scaled = num / Math.pow(10, tier * 3);

  return scaled % 1 === 0 ? scaled + suffix : scaled.toFixed(2) + suffix;
}

export function formatPrice(price: number) {
  if (price >= 0.01) {
    return price.toFixed(2);
  } else {
    return price.toFixed(7).replace(/0+$/, '').slice(0, -1);
  }
}

export function parseTimeDifference(timestamp: string) {
  const now = new Date().getTime();
  const time = new Date(timestamp).getTime();
  const diffInSeconds = Math.floor((now - time) / 1000);

  if (diffInSeconds < 0) {
    return 'Invalid timestamp (future date)';
  }

  const days = Math.floor(diffInSeconds / (60 * 60 * 24));
  if (days > 0) return `${days}d`;

  const hours = Math.floor(diffInSeconds / (60 * 60));
  if (hours > 0) return `${hours}h`;

  const minutes = Math.floor(diffInSeconds / 60);
  if (minutes > 0) return `${minutes}m`;

  return `${diffInSeconds}s`;
}
